import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, Card, CardActionArea, CardContent } from '@mui/material';
import { Link } from 'react-router-dom';
import { apigetPublic } from '../../service/api'; // Adjusted to match Blog API call

const Carousel = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await apigetPublic('blog'); // Using the same API call as Blog
        if (response?.status === 200 && response.data?.posts?.length > 0) {
          setPosts(response.data.posts.slice(0, 3)); // Limiting to the first 3 posts
        }
      } catch (error) {
        console.error('Error fetching posts:', error);
      }
    };

    fetchPosts();
  }, []);

  return (
    <Box>
      {/* H1 heading for this component */}
      <Typography
        variant="h4"
        component="h1"
        sx={{ fontWeight: 800, mb: 4 }}
      >
        Our Blog
      </Typography>

      {posts.length === 0 ? (
        <Typography>Loading...</Typography>
      ) : (
        <Grid container spacing={4}>
          {posts.map((post) => (
            <Grid item xs={12} sm={6} md={4} key={post._id}>
              <Card
                sx={{
                  borderRadius: 2,
                  boxShadow: 3,
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                  '&:hover': {
                    boxShadow: 8,
                    transform: 'translateY(-4px)',
                  }
                }}
              >
                <CardActionArea
                  component={Link}
                  to={`/blog/${post.slug || post._id}`}
                  sx={{ height: '100%' }}
                >
                  {post.imageUrl && (
                    <img
                      src={post.imageUrl}
                      alt={post.title}
                      style={{
                        width: '100%',
                        height: '200px',
                        objectFit: 'cover'
                      }}
                    />
                  )}
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      {post.title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                      {post.previewBlurb}...
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default Carousel;
